import {FirebaseService} from "../firebase/FirebaseService";

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * Service class that contains method for delete operations
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 * @constructor
 */
export class DeleteAtDatabaseService {
  /**
   * Removed the not present action from database
   *
   * @param trackingID
   */
  public static async removeNotPresentAction(trackingID: string) {
    await FirebaseService.dbRef()
      .deliveries()
      .child(trackingID)
      .child("chosenNotPresentOption")
      .remove();
  }

  /**
   * Removes the previously booked help from the delivery
   *
   * @param trackingID
   */
  public static async removePreviouslyBookedHelp(trackingID: string) {
    await FirebaseService.dbRef()
      .deliveries()
      .child(trackingID)
      .child("bookedHelp")
      .remove();
  }

    /**
     * Removes that the receiver is present to accept the delivery
     *
     * @param trackingID
     */
    public static async removeReceiverIsPresent(trackingID: string) {
        await FirebaseService.dbRef()
            .deliveries()
            .child(trackingID)
            .child("isPresent")
            .remove();
    }
}
